import styled from 'styled-components';
import { c7239C4, cFFFFFF } from '#/colors';

const Button = styled.button`
  background-color: ${c7239C4};
  border-radius: 7px;
  border: none;
  color: ${cFFFFFF};
  font-size: 13px;
  font-weight: 700;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;
  }
`;

export default Button;
